var chunkMapping = {
	"71": [
		71
	],
	"105": [
		105
	],
	"210": [
		210
	],
	"237": [
		237
	],
	"282": [
		282
	],
	"302": [
		302
	],
	"411": [
		411
	],
	"427": [
		427
	],
	"538": [
		538
	],
	"669": [
		669
	],
	"932": [
		932
	],
	"951": [
		951
	],
	"973": [
		973
	],
	"1123": [
		1123
	],
	"1203": [
		1203
	],
	"1204": [
		1204
	],
	"1223": [
		1223
	],
	"1247": [
		1247
	],
	"1325": [
		1325
	],
	"1330": [
		1330
	],
	"1392": [
		1392
	],
	"1534": [
		1534
	],
	"1642": [
		1642
	],
	"1659": [
		1659
	],
	"1996": [
		1996
	],
	"2084": [
		2084
	],
	"2158": [
		2158
	],
	"2183": [
		2183
	],
	"2227": [
		2227
	],
	"2570": [
		2570
	],
	"2689": [
		2689
	],
	"2734": [
		2734
	],
	"2909": [
		2909
	],
	"2922": [
		2922
	],
	"2933": [
		2933
	],
	"3119": [
		3119
	],
	"3516": [
		3516
	],
	"3757": [
		3757
	],
	"3849": [
		3849
	],
	"3901": [
		3901
	],
	"4075": [
		4075
	],
	"4086": [
		4086
	],
	"4163": [
		4163
	],
	"4469": [
		4469
	],
	"4929": [
		4929
	],
	"4989": [
		4989
	],
	"5062": [
		5062
	],
	"5090": [
		2709
	],
	"5122": [
		5122
	],
	"5257": [
		5257
	],
	"5269": [
		5269
	],
	"5277": [
		5277
	],
	"5313": [
		5313
	],
	"5600": [
		5600
	],
	"5667": [
		5667
	],
	"5696": [
		5696
	],
	"5779": [
		5779
	],
	"5788": [
		5788
	],
	"5846": [
		5846
	],
	"5851": [
		1089
	],
	"5853": [
		5853
	],
	"5874": [
		5874
	],
	"5899": [
		5899
	],
	"5940": [
		5940
	],
	"6027": [
		6027
	],
	"6113": [
		6113
	],
	"6193": [
		6193
	],
	"6219": [
		6219
	],
	"6286": [
		6286
	],
	"6406": [
		6406
	],
	"6528": [
		6528
	],
	"6893": [
		6893
	],
	"6963": [
		6963
	],
	"7074": [
		7074
	],
	"7144": [
		7144
	],
	"7195": [
		7195
	],
	"7222": [
		7222
	],
	"7332": [
		7332
	],
	"7394": [
		7394
	],
	"7490": [
		7490
	],
	"7517": [
		7517
	],
	"7576": [
		7576
	],
	"7761": [
		7761
	],
	"7776": [
		7776
	],
	"7795": [
		7795
	],
	"7826": [
		7826
	],
	"7961": [
		7961
	],
	"8000": [
		8000
	],
	"8226": [
		8226
	],
	"8232": [
		5851
	],
	"8245": [
		8245
	],
	"8434": [
		8434
	],
	"8552": [
		8552
	],
	"8710": [
		8710
	],
	"8788": [
		8788
	],
	"8824": [
		8824
	],
	"8896": [
		8896
	],
	"8947": [
		1328
	],
	"8992": [
		8992
	],
	"8999": [
		8999
	],
	"9052": [
		9052
	],
	"9098": [
		9098
	],
	"9107": [
		9107
	],
	"9152": [
		9152
	],
	"9298": [
		9298
	],
	"9343": [
		9343
	],
	"9438": [
		9438
	],
	"9448": [
		9448
	],
	"9487": [
		9487
	],
	"9566": [
		9566
	],
	"9572": [
		9572
	],
	"9582": [
		9582
	],
	"9594": [
		9594
	],
	"9609": [
		9609
	],
	"9817": [
		9817
	],
	"9909": [
		9909
	]
};
var idToExternalAndNameMapping = {
	"71": [
		"default",
		"./page",
		3146
	],
	"105": [
		"default",
		"./page",
		1259
	],
	"210": [
		"default",
		"./saga",
		8695
	],
	"237": [
		"default",
		"./page",
		9688
	],
	"282": [
		"default",
		"./reducer",
		8695
	],
	"302": [
		"default",
		"./saga",
		6776
	],
	"411": [
		"default",
		"./style",
		6414
	],
	"427": [
		"default",
		"./translation",
		3146
	],
	"538": [
		"default",
		"./translation",
		3742
	],
	"669": [
		"default",
		"./reducer",
		9082
	],
	"932": [
		"default",
		"./reducer",
		1259
	],
	"951": [
		"default",
		"./translation",
		8695
	],
	"973": [
		"default",
		"./Loader",
		4615
	],
	"1089": [
		"default",
		"./reducer",
		3941
	],
	"1123": [
		"default",
		"./saga",
		513
	],
	"1203": [
		"default",
		"./page",
		9275
	],
	"1204": [
		"default",
		"./saga",
		1259
	],
	"1223": [
		"default",
		"./style",
		1259
	],
	"1247": [
		"default",
		"./page",
		3283
	],
	"1325": [
		"default",
		"./page",
		6414
	],
	"1328": [
		"default",
		"./reducer",
		3742
	],
	"1330": [
		"default",
		"./style",
		513
	],
	"1392": [
		"default",
		"./translation",
		5395
	],
	"1534": [
		"default",
		"./style",
		6618
	],
	"1642": [
		"default",
		"./saga",
		9275
	],
	"1659": [
		"default",
		"./page",
		8695
	],
	"1996": [
		"default",
		"./page",
		3941
	],
	"2084": [
		"default",
		"./translation",
		9082
	],
	"2158": [
		"default",
		"./reducer",
		3146
	],
	"2183": [
		"default",
		"./saga",
		6618
	],
	"2227": [
		"default",
		"./saga",
		3026
	],
	"2570": [
		"default",
		"./style",
		2394
	],
	"2689": [
		"default",
		"./translation",
		1259
	],
	"2709": [
		"default",
		"./page",
		3026
	],
	"2734": [
		"default",
		"./saga",
		3283
	],
	"2909": [
		"default",
		"./reducer",
		513
	],
	"2922": [
		"default",
		"./page",
		2394
	],
	"2933": [
		"default",
		"./page",
		5859
	],
	"3119": [
		"default",
		"./saga",
		5395
	],
	"3516": [
		"default",
		"./translation",
		8277
	],
	"3757": [
		"default",
		"./reducer",
		3026
	],
	"3849": [
		"default",
		"./reducer",
		5395
	],
	"3901": [
		"default",
		"./reducer",
		5466
	],
	"4075": [
		"default",
		"./reducer",
		4624
	],
	"4086": [
		"default",
		"./Title",
		4615
	],
	"4163": [
		"default",
		"./saga",
		5466
	],
	"4469": [
		"default",
		"./translation",
		5859
	],
	"4929": [
		"default",
		"./reducer",
		6618
	],
	"4989": [
		"default",
		"./translation",
		4919
	],
	"5062": [
		"default",
		"./reducer",
		3283
	],
	"5122": [
		"default",
		"./page",
		5466
	],
	"5257": [
		"default",
		"./saga",
		3742
	],
	"5269": [
		"default",
		"./reducer",
		2394
	],
	"5277": [
		"default",
		"./page",
		4919
	],
	"5313": [
		"default",
		"./saga",
		3941
	],
	"5600": [
		"default",
		"./saga",
		4919
	],
	"5667": [
		"default",
		"./HeroSlider",
		4615
	],
	"5696": [
		"default",
		"./saga",
		9688
	],
	"5779": [
		"default",
		"./style",
		5859
	],
	"5788": [
		"default",
		"./translation",
		2394
	],
	"5846": [
		"default",
		"./page",
		5395
	],
	"5851": [
		"default",
		"./style",
		4919
	],
	"5853": [
		"default",
		"./style",
		9275
	],
	"5874": [
		"default",
		"./translation",
		4624
	],
	"5899": [
		"default",
		"./saga",
		2394
	],
	"5940": [
		"default",
		"./translation",
		5466
	],
	"6027": [
		"default",
		"./SlickSlider",
		4615
	],
	"6113": [
		"default",
		"./reducer",
		1097
	],
	"6193": [
		"default",
		"./saga",
		4624
	],
	"6219": [
		"default",
		"./saga",
		8277
	],
	"6286": [
		"default",
		"./page",
		6618
	],
	"6406": [
		"default",
		"./style",
		5395
	],
	"6528": [
		"default",
		"./reducer",
		4919
	],
	"6893": [
		"default",
		"./translation",
		9688
	],
	"6963": [
		"default",
		"./saga",
		9082
	],
	"7074": [
		"default",
		"./translation",
		3941
	],
	"7144": [
		"default",
		"./translation",
		6618
	],
	"7195": [
		"default",
		"./style",
		9688
	],
	"7222": [
		"default",
		"./saga",
		3146
	],
	"7332": [
		"default",
		"./translation",
		3026
	],
	"7394": [
		"default",
		"./style",
		3026
	],
	"7490": [
		"default",
		"./page",
		9082
	],
	"7517": [
		"default",
		"./translation",
		6414
	],
	"7576": [
		"default",
		"./translation",
		1097
	],
	"7761": [
		"default",
		"./style",
		3146
	],
	"7776": [
		"default",
		"./reducer",
		9688
	],
	"7795": [
		"default",
		"./translation",
		3283
	],
	"7826": [
		"default",
		"./reducer",
		9275
	],
	"7961": [
		"default",
		"./style",
		6776
	],
	"8000": [
		"default",
		"./saga",
		6414
	],
	"8226": [
		"default",
		"./style",
		5466
	],
	"8245": [
		"default",
		"./style",
		8695
	],
	"8434": [
		"default",
		"./page",
		513
	],
	"8552": [
		"default",
		"./saga",
		5859
	],
	"8710": [
		"default",
		"./reducer",
		6776
	],
	"8788": [
		"default",
		"./page",
		3742
	],
	"8824": [
		"default",
		"./reducer",
		5859
	],
	"8896": [
		"default",
		"./style",
		4624
	],
	"8992": [
		"default",
		"./style",
		3941
	],
	"8999": [
		"default",
		"./saga",
		1097
	],
	"9052": [
		"default",
		"./page",
		4624
	],
	"9098": [
		"default",
		"./style",
		8277
	],
	"9107": [
		"default",
		"./translation",
		6776
	],
	"9152": [
		"default",
		"./reducer",
		6414
	],
	"9298": [
		"default",
		"./style",
		9082
	],
	"9343": [
		"default",
		"./page",
		6776
	],
	"9438": [
		"default",
		"./style",
		1097
	],
	"9448": [
		"default",
		"./style",
		3742
	],
	"9487": [
		"default",
		"./translation",
		9275
	],
	"9566": [
		"default",
		"./page",
		1097
	],
	"9572": [
		"default",
		"./translation",
		513
	],
	"9582": [
		"default",
		"./SplideSlider",
		4615
	],
	"9594": [
		"default",
		"./page",
		8277
	],
	"9609": [
		"default",
		"./Section",
		4615
	],
	"9817": [
		"default",
		"./style",
		3283
	],
	"9909": [
		"default",
		"./reducer",
		8277
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}